import LegalLayout from "@/pages/legal/LegalLayout";

export default function CCPAPage() {
  return (
    <LegalLayout
      title="Your California Privacy Rights (CCPA / CPRA)"
      eyebrow="California Notice"
      lastUpdated="February 1, 2026"
      testid="ccpa-page"
    >
      <p>
        This notice is provided by <strong>Ministry Branch</strong> (a ChurchFlow service) to California
        residents under the California Consumer Privacy Act of 2018, as amended by the California Privacy
        Rights Act of 2020 (collectively, the <strong>"CCPA/CPRA"</strong>). It supplements our{" "}
        <a href="/legal/privacy">Privacy Policy</a>.
      </p>

      <h2>1. Categories of Personal Information We Collect</h2>
      <p>In the past 12 months we may have collected the following categories of personal information:</p>
      <ul>
        <li><strong>Identifiers</strong> — name, email address, postal address, account ID, IP address.</li>
        <li><strong>Customer records (Cal. Civ. Code §1798.80(e))</strong> — billing/contact information.</li>
        <li><strong>Commercial information</strong> — subscription history.</li>
        <li><strong>Internet / network activity</strong> — log data, browser type, pages visited within the Service.</li>
        <li><strong>Geolocation</strong> — approximate location derived from IP address (city / region only).</li>
        <li><strong>Inferences</strong> — limited inferences about feature usage.</li>
      </ul>
      <p>
        We do <strong>not</strong> knowingly collect "sensitive personal information" as defined by the CPRA for
        purposes of inferring characteristics. The donor records you enter are <strong>Customer Data</strong> that
        belong to your organization; we process those records on your behalf as a <strong>service provider</strong>.
      </p>

      <h2>2. Sources</h2>
      <ul>
        <li>Directly from you when you register or use the Service;</li>
        <li>Automatically from your device and browser;</li>
        <li>From our service providers (e.g., hosting and analytics vendors).</li>
      </ul>

      <h2>3. Purposes</h2>
      <p>We use personal information for the purposes described in our Privacy Policy, including providing the Service, security, support, legal compliance, and product improvement.</p>

      <h2>4. Disclosure to Third Parties</h2>
      <p>
        In the past 12 months we have disclosed Identifiers and Internet/network-activity information to service
        providers (hosting, email delivery, analytics) for a business purpose, under written contracts that
        prohibit them from using the information for any other purpose.
      </p>

      <h2>5. Sale or "Sharing" of Personal Information</h2>
      <p>
        <strong>We do not sell personal information for money.</strong> We also do not "share" personal
        information for cross-context behavioral advertising as those terms are defined under the CPRA.
        Accordingly, there is nothing to opt out of for cross-context behavioral advertising; if that changes,
        we will provide a "Do Not Sell or Share My Personal Information" link on every page and update this
        notice.
      </p>

      <h2>6. Retention</h2>
      <p>
        We retain each category of personal information for as long as needed to provide the Service and to
        comply with our legal obligations. See the Privacy Policy for details.
      </p>

      <h2>7. Your CCPA / CPRA Rights</h2>
      <p>If you are a California resident, you have the right to:</p>
      <ul>
        <li><strong>Know</strong> what personal information we collect, use, disclose, and (if applicable) sell or share about you;</li>
        <li><strong>Access</strong> a copy of the specific pieces of personal information we hold about you;</li>
        <li><strong>Correct</strong> inaccurate personal information;</li>
        <li><strong>Delete</strong> personal information we have collected from you (subject to legal exceptions);</li>
        <li><strong>Opt out</strong> of the sale or sharing of personal information (not applicable — we do neither);</li>
        <li><strong>Limit the use of sensitive personal information</strong> (not applicable — we do not use sensitive PI to infer characteristics);</li>
        <li><strong>Non-discrimination</strong> — we will not discriminate against you for exercising any of these rights.</li>
      </ul>

      <h2>8. How to Exercise Your Rights</h2>
      <p>
        Submit a request by emailing <a href="mailto:privacy@ministrybranch.com">privacy@ministrybranch.com</a>{" "}
        with the subject "CCPA Request." We will verify your identity using information already associated with
        your account before fulfilling the request. We will respond within 45 days; we may extend the period by
        an additional 45 days with notice as permitted by law.
      </p>

      <h3>Authorized Agents</h3>
      <p>
        You may designate an authorized agent to make a request on your behalf. We will require written proof
        that you have authorized the agent and may verify your identity directly.
      </p>

      <h2>9. Shine the Light (Cal. Civ. Code §1798.83)</h2>
      <p>
        California residents may request information about disclosures of their personal information to third
        parties for those parties' direct marketing purposes. <strong>Ministry Branch does not disclose personal
        information to third parties for their own direct marketing purposes.</strong>
      </p>

      <h2>10. Contact</h2>
      <p>
        Ministry Branch · Fresno, California · USA<br />
        <a href="mailto:privacy@ministrybranch.com">privacy@ministrybranch.com</a><br />
        <a href="mailto:legal@ministrybranch.com">legal@ministrybranch.com</a>
      </p>
    </LegalLayout>
  );
}
